import Swiper from 'swiper/dist/js/swiper.js'
import { TimelineMax } from 'gsap'
import stick_in_parent from 'sticky-kit/dist/sticky-kit'
import _ from 'lodash'

/**
 * INIT
 * ----
 * This function initialize every element of the single post
 **/
export function init() {
  initSlider()
  initFixedPost()
}

// fixed post
function initFixedPost() {
  initFixedPostStart()
  window.addEventListener('resize', _.debounce(checkFixedPost, 100), false);
}
function initFixedPostStart() {
  $('.homepage__post1fixed-n-small--left').each( function() {
    let $this = $(this)

    $this.find('article').stick_in_parent({
      offset_top: $('.header-bar').height() + 20
    })
    $this.addClass('fixed')
  })
}
function checkFixedPost() {
  if($(window).width() < 768) {
    $('.homepage__post1fixed-n-small--left').each( function() {
      let $this = $(this)

      $this.find('article').trigger('sticky_kit:detach')
      $this.removeClass('fixed')
    })
  } else {
    $('.homepage__post1fixed-n-small--left').each( function() {
      let $this = $(this)

      if(!$this.hasClass('fixed')) {
        $this.find('article').stick_in_parent({
          offset_top: $('.header-bar').height() + 20
        })
        $this.addClass('fixed')
      }
    })
  }
}

// sliders
function initSlider() {
  let sliderIssues = []
  document.querySelectorAll('.issues-slider').forEach((el, index) => {
    sliderIssues[index] = new Swiper(el, {
      slidesPerView: 1,
      loop: false,
      grabCursor: false,
      pagination: {
        el: el.querySelectorAll('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: el.querySelectorAll('.latest-issues__nav-next'),
        prevEl: el.querySelectorAll('.latest-issues__nav-prev')
      },
      mousewheel: false,
      keyboard: false
    })
  })

  let sliderFull = []
  document.querySelectorAll('.homepage__slider--container').forEach((el, index) => {
    sliderFull[index] = new Swiper(el, {
      slidesPerView: 1,
      loop: false,
      grabCursor: false,
      navigation: {
        nextEl: el.querySelectorAll('.homepage__slider--nav-next'),
        prevEl: el.querySelectorAll('.homepage__slider--nav-prev')
      },
      pagination: {
        el: el.querySelectorAll('.homepage__slider--pagination'),
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      mousewheel: false,
      keyboard: true
    })
  })
}



// WEBPACK FOOTER //
// ./scripts/components/Homepage.js